<template>
  <div v-if="!hasOrganizerAccess && !loadingProfile">
    <no-data-message v-if="nonOrganizerText">
      <v-icon slot="icon">flag</v-icon>
      <template slot="message">
        {{ nonOrganizerText }}
      </template>
    </no-data-message>
  </div>
  <div v-else-if="loadingProfile" class="loader-container">
    <loader></loader>
  </div>
  <v-app v-else class="white">
    <div class="white pb-2 main">
      <div class="main">
        <completion-list v-if="!loadingProfile"></completion-list>
      </div>
    </div>
  </v-app>
</template>

<script>
import organizer from '@/mixins/organizer';
import CompletionList from '@/components/shared/CompletionList';

export default {
  mixins: [organizer],
  components: { CompletionList },
};
</script>

<style lang="scss" scoped>
@import "~styles/shared.scss";

.main {
  height: 100%;
}

.loader-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  height: 80%;
}
</style>



// WEBPACK FOOTER //
// src/components/OrganizerCompletions.vue